import ProjectMap from './ProjectMap';
export default ProjectMap;